<div class="side-menu">
    <div v-for="(category, index) in menuCategories" :key="index">
        <SideMenuTitle :title="category.title" :to="category.to" />

        <div v-if="category.items">
            <SideMenuItem
                v-for="(item, index) in category.items.filter((i) =>
                    isMenuItemVisible(
                        i.allowedRoles,
                        i.allowedRoleTypes,
                        i.claims
                    )
                )"
                :key="index"
                :item="item" />
        </div>
    </div>
</div>